module.exports = __webpack_public_path__ + "static/media/clasificacion.b4f200a4.svg";